<template>
  <b-card no-body>
    <b-table
      id="teams"
      ref="table"
      class="bg-white"
      responsive
      show-empty
      :fields="fields"
      :items="teams"
    >
      <template v-slot:empty>
        <p align="center">
          <span v-if="!busy">{{ trans('none') }}</span>
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
            {{ trans('please_wait') }}
          </span>
        </p>
      </template>
      <template v-slot:cell(name)="data">
        <b-row>
          <b-col class="col-auto">
            <img v-if="!!data.item.image_url" :src="data.item.image_url" style="max-height: 40px;" />
            <span v-if="!data.item.image_url" class="h2"><i class="fa fa-fw fa-tshirt text-muted"></i></span>
          </b-col>
          <b-col>
            {{ data.value }}
            <sup v-if="data.item.deleted_at">
              <b-badge variant="danger">{{ trans('archived') }}</b-badge>
            </sup>
            <tags
              :organization="organization"
              :model="data.item"
              type="class"
              hide-edit
            ></tags>
          </b-col>
        </b-row>
        <events-schedule
          :organization="organization"
          :cls="data.item"
          :events="data.item.events"
        ></events-schedule>
      </template>
      <template v-slot:cell(participant_count)="data">
        <b-button variant="link" class="p-0" @click="onClickPlayers(data.item)" :disabled="busy || data.value == 0">
          <i class="fa fa-fw fa-users"></i>
          {{ data.value }}
          <span v-if="data.item.maximum_attendance">/ {{ data.item.maximum_attendance }}</span>
        </b-button>
      </template>
      <template #cell(invoice_total)="data">
        <span v-if="data.value !== null">
          {{ numeral(data.value).format('1,000.00') }}
        </span>
      </template>
      <template #cell(invoice_balance)="data">
        <span v-if="data.value !== null" :class="data.value > 0 ? 'text-danger' : ''">
          {{ numeral(data.value).format('1,000.00') }}
        </span>
      </template>
    </b-table>
    <team-players-modal
      :organization="organization"
      :team="team"
      hide-invoice-links
    ></team-players-modal>
  </b-card>
</template>

<script>
  import EventsSchedule from './../class/EventsSchedule2'
  import TeamPlayersModal from './../team/TeamPlayersModal'
  import Tags from './../tag/Tags'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      EventsSchedule,
      TeamPlayersModal,
      Tags,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        busy: false,
        error: null,
        teams: null,
        team: null,
      }
    },
    computed: {
      fields() {
        return _.compact([
          {key: 'name', label: trans('team')},
          {key: 'participant_count', label: trans('players')},
          {key: 'invoice_total', label: trans('total')},
          {key: 'invoice_balance', label: trans('balance')},
        ])
      },
    },
    methods: {
      onClickPlayers(team) {
        this.team = team
        this.$bvModal.show('team-players-modal')
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/teams`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.teams = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.teams = []
        })
      },
    },
    mounted() {
      window.myTeams = this
      this.fetch()
    },
  }
</script>
